import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
export const getStaticContent = createAsyncThunk(
  "get/staticContent",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("getStaticContent", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const editStaticContent = createAsyncThunk(
  "edit/staticContent",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editStaticContent", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);

const staticContent = createSlice({
  name: "staticContent",
  initialState: {
    content: "",
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getStaticContent.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getStaticContent.fulfilled, (state, action) => {
      state.loading = false;
      state.content = action.payload;
    });
    builder.addCase(getStaticContent.rejected, (state, action) => {
      state.loading = false;
      console.log(action.payload);
    });
  },
});
export default staticContent.reducer;
